import * as React from "react"
import "./toolbar.scss"

export interface ToolbarProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export const Toolbar = React.forwardRef<HTMLDivElement, ToolbarProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`tiptap-toolbar ${className || ""}`}
        role="toolbar"
        {...props}
      >
        {children}
      </div>
    )
  }
)

Toolbar.displayName = "Toolbar"

export interface ToolbarGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export const ToolbarGroup: React.FC<ToolbarGroupProps> = ({ 
  className, 
  children, 
  ...props 
}) => {
  return (
    <div className={`tiptap-toolbar-group ${className || ""}`} {...props}>
      {children}
    </div>
  )
}

export const ToolbarSeparator: React.FC = () => {
  return <div className="tiptap-toolbar-separator" role="separator" />
}
